// Illustrative updates for the marketing preview, not a live account feed.
export const ACCOUNT_UPDATES = [
  {
    account: 'Quillstack',
    change: 'New commercial leader',
    source: 'Company announcement',
    compactSource: 'Announcement',
    date: 'Sep 04',
    action: 'revisit the buying group.',
    sourceMark: 0
  },
  {
    account: 'Brightvault',
    change: 'New trust center',
    source: 'Trust center',
    compactSource: 'Trust center',
    date: 'Sep 04',
    action: 'review security requirements.',
    sourceMark: 1
  },
  {
    account: 'Cedarpath',
    change: 'New enterprise package',
    source: 'Pricing page',
    compactSource: 'Pricing page',
    date: 'Sep 04',
    action: 'revisit account fit.',
    sourceMark: 1
  },
  {
    account: 'Quillstack',
    change: 'RevOps team expanding',
    source: 'Careers page',
    compactSource: 'Careers page',
    date: 'Sep 04',
    action: 'map the new operations roles.',
    sourceMark: 0
  },
  {
    account: 'Brightvault',
    change: 'Audit program launched',
    source: 'Company announcement',
    compactSource: 'Announcement',
    date: 'Sep 04',
    action: 'review compliance priorities.',
    sourceMark: 1
  },
  {
    account: 'Cedarpath',
    change: 'European team hiring',
    source: 'Careers page',
    compactSource: 'Careers page',
    date: 'Sep 04',
    action: 'check regional ownership.',
    sourceMark: 0
  },
  {
    account: 'Quillstack',
    change: 'New integration launched',
    source: 'Product updates',
    compactSource: 'Product updates',
    date: 'Sep 04',
    action: 'review the current tool stack.',
    sourceMark: 1
  },
  {
    account: 'Brightvault',
    change: 'New security partner',
    source: 'Partner directory',
    compactSource: 'Partner page',
    date: 'Sep 04',
    action: 'review partner overlap.',
    sourceMark: 1
  },
  {
    account: 'Cedarpath',
    change: 'API access added',
    source: 'Product updates',
    compactSource: 'Product updates',
    date: 'Sep 04',
    action: 'revisit technical fit.',
    sourceMark: 1
  },
  {
    account: 'Quillstack',
    change: 'New operations leader',
    source: 'Company announcement',
    compactSource: 'Announcement',
    date: 'Sep 04',
    action: 'refresh the buying group.',
    sourceMark: 0
  },
  {
    account: 'Cedarpath',
    change: 'Enterprise pricing changed',
    source: 'Pricing page',
    compactSource: 'Pricing page',
    date: 'Sep 01',
    action: 'review packaging changes.',
    sourceMark: 1
  },
  {
    account: 'Brightvault',
    change: 'First security hire',
    source: 'Careers page',
    compactSource: 'Careers page',
    date: 'Sep 02',
    action: 'find the new security owner.',
    sourceMark: 0
  }
] as const;

export type AccountUpdate = (typeof ACCOUNT_UPDATES)[number];

export const MONITORING_CYCLE_MS = 5000;
export const MONITORING_INTRO_MS = 1050;

export function accountUpdateAt(sequence: number): AccountUpdate {
  const index =
    ((sequence % ACCOUNT_UPDATES.length) + ACCOUNT_UPDATES.length) %
    ACCOUNT_UPDATES.length;
  return ACCOUNT_UPDATES[index]!;
}

export function monitoringSequences(
  cursor: number,
  arrived: boolean
): number[] {
  return arrived ? [cursor, cursor - 1, cursor - 2] : [cursor - 1, cursor - 2];
}
